import React from 'react';
import moment from 'moment';
import 'moment-timezone';
import { SERVER_TIMEZONE } from '@ally/date-utils';
import { isExternal } from '@ally/transfer-account-utils';
import { Details, Term } from '../shared';
import { getTransferType } from '../..';
var DEFAULT_FORMAT = 'dddd, MMM Do, YYYY';
function getWithdrawalDateText(withdrawalDate, dateFormat) {
    var today = moment.tz(SERVER_TIMEZONE);
    var isImmediate = withdrawalDate.isSame(today, 'day');
    if (isImmediate)
        return "We'll withdraw funds immediately";
    return "We'll withdraw funds on ".concat(withdrawalDate.format(dateFormat));
}
var DeliveryDateDisplay = function (_a) {
    var transfer = _a.transfer, _b = _a.dateFormat, dateFormat = _b === void 0 ? DEFAULT_FORMAT : _b;
    var deliveryDate = transfer.deliveryDate, withdrawalDate = transfer.withdrawalDate, fromAccount = transfer.fromAccount, toAccount = transfer.toAccount;
    var isInvest = getTransferType(fromAccount, toAccount) === 'INVEST';
    var isExternalTransfer = isExternal(fromAccount) || isExternal(toAccount);
    return (React.createElement(React.Fragment, null,
        React.createElement(Term, null, isInvest ? 'Start' : 'Deliver on'),
        React.createElement(Details, null,
            deliveryDate.format(dateFormat),
            isExternalTransfer && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                getWithdrawalDateText(withdrawalDate, dateFormat))))));
};
export default DeliveryDateDisplay;
//# sourceMappingURL=Display.js.map